export default {
	cod_proposta: {
		cod_vendedor: {
			vendedor: '',
		},
		cnpj: {
			cnpj: '',
			razao_social: '',
		},
	},
};



// WEBPACK FOOTER //
// ./src/components/contracts/js/reset.js